import styled, { css } from 'styled-components';
import Loader from 'react-loader-spinner';
import ThemedTooltip from '../../../../../../theme/ThemedTooltip';
import { fontDisplay, fontUi, pill } from '../../../../../../theme/typography';

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const StyledTeamSquadContainer = styled.section`
  max-height: 650px;
  overflow-y: auto;
  width: 100%;
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.text};
  > h3 {
    text-align: center;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.text};
  }
  @media only screen and (max-width: 1199px) {
    margin-bottom: 40px;
  }
`;
export const StyledMatch = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0 15px;
  height: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  color: ${({ theme }) => theme.text};
  img {
    max-width: 25px;
    height: auto;
    width: 100%;
    max-height: 25px;
  }
  &:last-child {
    border-bottom: 0;
  }
  &[data-type='transfers'] {
    span {
      display: block;
      flex: none;
    }
  }
`;

export const StyledCard = styled.div`
  max-height: 400px;
  padding: 0;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  margin: 16px 30px 24px;
  overflow: hidden;
  @media only screen and (max-width: 991px) {
    margin: 16px 15px 24px;
  }
  h4 {
    font-family: 'Archivo', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14.222px;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: ${({ theme }) => theme.text};
  }
  p {
    margin: 14px 0;
    font-family: 'Archivo', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14.222px;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: ${({ theme }) => theme.textMuted};
  }
`;

export const StyledToggleView = styled.div`
  display: flex;
  position: relative;
  width: calc(100% - 60px);
  max-width: 350px;
  flex-direction: row;
  gap: 4px;
  padding: 3px;
  margin: 0 auto;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.hover};
`;
export const StyledToggleButton = styled.button`
  ${pill};
  ${fontUi};
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  flex: 1;
  color: ${({ theme }) => theme.textFaint};
  border: 0;
  outline: 0;
  padding: 8px 10px;
  cursor: pointer;
  background: transparent;
  -webkit-tap-highlight-color: transparent;

  ${({ isActive, theme }) => {
    if (isActive) {
      return css`
        color: ${theme.isDark ? theme.text : '#fff'};
        background: ${theme.isDark ? theme.card : theme.header};
      `;
    }
  }}
`;

export const StyledContext = styled.div`
  padding: 0 30px 20px 30px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  margin-bottom: 20px;
  h4 {
    font-weight: bold;
    font-size: 15px;
    color: ${({ theme }) => theme.text};
  }
  p {
    font-size: 13px;
    line-height: 22px;
    opacity: 0.9;
    color: ${({ theme }) => theme.textMuted};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.text};
  min-height: 112px;
  z-index: 1;
  position: sticky;
  top: 0;
  padding: 20px 30px 16px;
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    min-height: 0;
    padding-top: 16px;
  }
`;
export const StyledImage = styled.div`
  position: relative;
  width: 108px;
  height: 80px;
  margin-right: 16px;
  flex-shrink: 0;
  @media only screen and (max-width: 991px) {
    margin-right: 0;
    margin-bottom: 8px;
  }
`;

export const StyledKitPeek = styled.div`
  position: absolute;
  right: -4px;
  bottom: -2px;
  z-index: 1;
  pointer-events: none;
  img {
    width: 72px;
    height: auto;
    max-height: 84px;
    object-fit: contain;
  }
`;

export const StyledCrest = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  img {
    display: block;
    width: 68px;
    height: 68px;
    object-fit: contain;
    background: none;
    border: 0;
    filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.22));
  }
`;
export const StyledTeamInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
export const StyledTeamName = styled.h3`
  ${fontDisplay};
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 991px) {
    text-align: center;
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 6px;
  }
`;
export const StyledLeagueName = styled.span`
  color: ${({ theme }) => theme.textMuted};
  font-size: 13px;
  font-family: 'Archivo', sans-serif;
  font-weight: 500;
  @media only screen and (max-width: 991px) {
    text-align: center;
  }
`;

export const StyledWinnerSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  margin-bottom: 15px;
  color: ${({ theme }) => theme.text};
`;
export const StyledManagerCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 30px;
  @media only screen and (max-width: 991px) {
    text-align: center;
  }

  h4 {
    color: ${({ theme }) => theme.textFaint};
    font-size: 12px;
    opacity: 1;
  }
`;
export const StyledManagerName = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  text-decoration: ${({ isClickable }) => (isClickable ? 'underline' : 'none')};
`;
export const StyledWinnerCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
`;
export const StyledWinnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-left: 1px solid ${({ theme }) => theme.border};
  align-items: center;
  width: 100%;
  padding: 0 30px;
  @media only screen and (max-width: 991px) {
    display: none;
  }
`;
export const StyledWinnerSeasonNumber = styled.span`
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.textMuted};
`;
export const StyledWinnerLabel = styled.span`
  ${pill};
  margin-top: 5px;
  width: 22px;
  height: 22px;
  background-color: #fdca40;
  color: #000;
  font-size: 12px;
  font-weight: 700;
`;

export const StyledTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.text};
`;

export const StyledMatchName = styled.div`
  display: flex;
  flex-direction: row;
  width: 215px;
  align-items: center;
  justify-content: ${({ left }) => (left ? 'flex-start' : 'flex-end')};
  ${StyledTitle} {
    padding: ${({ left }) => (left ? '0 0 0 15px' : '0 15px 0 0 ')};
    @media only screen and (max-width: 991px) {
      max-width: 110px;
      text-align: ${({ left }) => (left ? 'left' : 'right')};
      padding: ${({ left }) => (left ? '0 0 0 10px' : '0 10px 0 0 ')};
    }
  }
`;

export const StyledScore = styled.div`
  display: flex;
  flex-direction: row;
  width: 35px;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 991px) {
    width: 65px;
  }
`;

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  min-width: 75px;
  &.__react_component_tooltip.show {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.text};
    font-size: 11px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledTransaction = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0px 0;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  padding: 0 15px 0 10px;
  height: 40px;
  &:last-child {
    border-bottom: 0;
  }
  &[data-type='revenue'] {
    span {
      color: #219653;
      &:before {
        margin-right: 1px;
        content: '+';
        font-family: 'Archivo', sans-serif;
        font-style: normal;
        font-size: 14px;
        line-height: 26px;
        color: #219653;
      }
    }
  }
  &[data-type='expenses'] {
    span {
      color: #eb5757;
      &:before {
        margin-right: 7px;

        font-family: 'Archivo', sans-serif;
        font-style: normal;
        font-size: 14px;
        line-height: 26px;
        color: #eb5757;
      }
    }
  }
  h4 {
    margin: 4px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-family: 'Archivo', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.text};
  }
  span {
    font-family: 'Archivo', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.text};
  }
  h6 {
    margin: 4px 0;
    display: flex;
    justify-content: space-between;
    font-family: 'Archivo', sans-serif;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.textFaint};
    span {
      font-family: 'Archivo', sans-serif;
      font-size: 12px;
      line-height: 100%;
      letter-spacing: -0.03em;
      color: ${({ theme }) => theme.textFaint};
    }
  }
`;

